import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_STAFF_DIRECTORY } from "./StaffDirectory.constants";
const StaffDirectory = Loadable(
  lazy(() =>
    import("./StaffDirectoryList").then(({ StaffDirectory }) => ({
      default: StaffDirectory,
    }))
  )
);
export const StaffDirectoryRoutes = [
  {
    path: `${APP_FILE_STAFF_DIRECTORY}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.STAFF_USER]}>
        <StaffDirectory />
      </AuthorizedRoute>
    ),
  },
];
